import { useMemo } from 'react';
import { LETTRES, LETTRE_HEX, QCM_GREEN } from '../../utils/qcmTheme';

/** Comptes par lettre, depuis les réponses (source de vérité : le serveur,
 *  complété par l'optimiste). Pur, testable. */
export const compterParLettre = (reponses) => {
  const c = { A: 0, B: 0, C: 0, D: 0 };
  for (const r of reponses || []) {
    if (c[r?.reponse] !== undefined) c[r.reponse] += 1;
  }
  return c;
};

/**
 * La répartition des réponses, EN DIRECT, sur l'écran de scan (chantier jeton,
 * 2026-09-04) : ce que la projection ne montre pas avant la révélation, et
 * que le professeur veut voir pour décider de faire discuter ou d'avancer.
 * Le téléphone est privé : la bonne réponse y est marquée en vert, pour lui.
 * Remplace l'ancien panneau de résultats, qui coûtait un écran par question.
 */
const RepartitionReponses = ({ reponses, bonneReponse }) => {
  const counts = useMemo(() => compterParLettre(reponses), [reponses]);
  const total = LETTRES.reduce((s, l) => s + counts[l], 0);
  return (
    <div className="px-4 pb-2" data-testid="repartition">
      <div className="flex h-[10px] rounded-full overflow-hidden gap-[2px]" style={{ background: 'rgba(255,255,255,.1)' }}>
        {LETTRES.map((l) => (
          <div
            key={l}
            className="h-full transition-[flex] duration-500"
            style={{
              flex: counts[l] > 0 ? `${counts[l]} 1 0%` : '0 1 0%',
              background: LETTRE_HEX[l],
            }}
          />
        ))}
      </div>
      <div className="flex justify-between mt-1.5">
        {LETTRES.map((l) => {
          const bonne = l === bonneReponse;
          return (
            <span
              key={l}
              data-testid={`repartition-${l}`}
              className="flex items-center gap-1 text-[12px] font-bold tabular-nums"
              style={{ color: bonne ? QCM_GREEN : 'rgba(255,255,255,.75)' }}
            >
              <span
                className="inline-flex items-center justify-center w-[18px] h-[18px] rounded-md text-[11px] text-white"
                style={{ background: LETTRE_HEX[l], outline: bonne ? `2px solid ${QCM_GREEN}` : 'none' }}
              >
                {l}
              </span>
              {counts[l]}
              {total > 0 ? <span className="font-medium" style={{ color: 'rgba(255,255,255,.45)' }}>·{Math.round((counts[l] / total) * 100)}%</span> : null}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default RepartitionReponses;
